var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"link",class:{
      'block': _vm.is_block === 'true',
      'cta': _vm.is_cta === 'true',
      'paddingBottom': _vm.padding === 'true'}},[(_vm.is_cta === 'true')?_c('span',{staticClass:"icon icon-arrow-right"}):_vm._e(),_c('b-link',{attrs:{"is_cta":_vm.is_cta,"is_block":_vm.is_block,"text":_vm.text,"to":_vm.toName,"href":_vm.externalLink,"target":_vm.target},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }